import React, { useEffect, useRef, useState } from "react"
import useAllSitePage from '../../hooks/useAllSitePage'
import Button from "../../shared/Button/Button"

import "./VideoBackground.scss"

const VideoBackground = ({
  video, title, description, button, strapi_component, id, backgroundImage, videoUrl
}) => {

  const [isVideoPause, setIsVideoPause] = useState(false)
  const videoRef = useRef(null)
  const pagesPath = useAllSitePage()
  const { allSitePage: matchPages } = pagesPath

  const pausePlay = () => {
    if (isVideoPause) {
      videoRef.current.play()
    } else {
      videoRef.current.pause()
    }
    setIsVideoPause(prev => !prev)
  }

  useEffect(() => {
    const isVideoPauseLocal =
      typeof window !== "undefined"
        ? localStorage.getItem("videoPaused")
        : undefined

    if (isVideoPauseLocal === "true") {
      videoRef.current.pause()
      setIsVideoPause(isVideoPauseLocal)
    }
  }, [])

  useEffect(() => {
    localStorage.setItem("videoPaused", isVideoPause)
  }, [isVideoPause])

  const url = videoUrl?.replace("watch?v=", "embed/")
  let code = url?.substring(url.lastIndexOf("/") + 1, url.length)
  const codeIndex = code?.indexOf("?")

  if (codeIndex !== -1 && code !== undefined) {
    code = code.substring(0, code.indexOf("?"))
  }

  return (
    <div
      className={`${backgroundImage && "py-3"} imageBg`}
      style={{
        backgroundImage: `url(${backgroundImage?.url})`, backgroundRepeatY: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center',
      }}
    >
      <div
        className="container px-md-0 px-lg-3 mx-auto videoBackground-container"
        id={strapi_component + "-" + id}
      >
        <section
          className="videoBackground"
        >
          {(video?.url !== null && video?.url !== undefined) ?
            <video
              className="video"
              ref={videoRef}
              muted
              autoPlay
              loop
              src={video.url}
              type="video/mp4"
              controls={false}
              onClick={pausePlay}
            /> : (videoUrl !== null && videoUrl !== undefined) && (
              <>
                {(url !== undefined && code !== undefined) && (
                  <iframe
                    className="video"
                    loading="lazy"
                    type="text/html"
                    srcDoc={`<style>*{padding:0;margin:0;overflow:hidden}html,body{height:100%}img,span{position:absolute;
                    width:100%;height:100%;object-fit: cover;top:0;bottom:0}span{height:1.5em;text-align:center;font:48px/1.5 sans-serif;color:white;margin:auto;text-shadow:0 0 0.5em black}</style>
                    <a href=${url + "?rel=0"}>
                    <img src=https://img.youtube.com/vi/${code}/hqdefault.jpg alt='Video' height='100%'>
                    <span>▶</span></a>`}
                    src={url + "?rel=0"}
                    allowFullScreen
                    border="0"
                    title="benefits_video"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    webkitallowfullscreen="true"
                    mozallowfullscreen="true"
                  ></iframe>
                )
                }
              </>
            )
          }

          {(description || title) &&
            <div className="videoBackground-card">
                {title &&
                  <div className="videoBackground-title">{title}</div>
                }
                {description &&
                  <div className="videoBackground-descrption">{description}</div>
                }
                {button && 
                  <Button
                    button={{label: button.content, ...button}}
                    customButton={{ variant: 'black_outline', size: "normal", shape: 'rectangle' }}
                    classContainer="d-flex"
                    matchPages={matchPages?.nodes} 
                  />
                }
            </div>
          }
        </section>
      </div> 
    </div>
  )
}

export default VideoBackground
